import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import AuthContext from 'common/auth';
import useApi from 'common/useApi';

import LoginCard from 'components/LoginCard';
import useFormApiErrors from 'common/useFormApiErrors';
import { useNavigate, useParams } from 'react-router-dom';

const AccountVerification = () => {
  const { tempToken } = useContext(AuthContext)!;
  const { key } = useParams();
  const endpoint = key ? '/api/verify-account' : '/api/me/send-verification-email';
  const { isLoading, isError, error, isSuccess, mutate } = useApi('post', endpoint);
  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, formState: { isSubmitting, isDirty, isValid }, setError } = formMethods;
  const navigate = useNavigate();

  useEffect(() => {
    if (!key && tempToken === '') {
      navigate('/login');
    }
  }, [tempToken]);

  const onSubmit = () => {
    if (key) {
      mutate({ key });
    } else {
      // S9: authenticated via the session cookie; no token to pass.
      mutate({});
    }
  };

  // Navigate only after verification succeeds, so a failed verify stays on the
  // form and shows the error instead of silently bouncing to login.
  useEffect(() => {
    if (isSuccess && key) {
      navigate('/login');
    }
  }, [isSuccess]);

  useFormApiErrors(
    isError,
    error,
    setError,
    isSuccess,
    key
      ? 'The account has been verified. Please log in to continue.'
      : 'Verification email sent.',
  );

  return (
    <LoginCard title={key ? 'Finish Verification' : 'Verification Required'} create={false} back={false}>
      {key
        ? <p>
          Click the button below to finish verifying your account.
        </p>
        : <p>
          Email verification is required to sign up.
          A verification email has been sent to your account.
          If you wish to re-send the email, click the button below.
        </p>
      }
      <p>&nbsp;</p>

      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <button
            className='primary big'
            disabled={isLoading || isSubmitting || (!isValid && isDirty)}
          >
            {key ? 'Verify account' : 'Re-send Verification Email'}
          </button>
          <hr />
        </form>
      </FormProvider>
    </LoginCard>
  );
};

export default AccountVerification;